module.exports = __webpack_public_path__ + "img/20190916170712653.7e28414b.jpg";